import Vue from 'vue'

// element-ui components are loaded on demand
//
// Instructions: https://element.eleme.io/#/en-US/component/quickstart
// Full list of components: https://github.com/ElemeFE/element/blob/master/components.json
import {
  Container,
  Header,
  Aside,
  Main,
  Row,
  // Col,
  Form,
  FormItem,
  Input,
  InputNumber,
  Checkbox,
  Button,
  ButtonGroup,
  Tooltip,
  Message,
  MessageBox,
  Notification,
  Loading,
  Alert,
  ColorPicker,
} from 'element-ui'

import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

// overwrite ElCol component
import ElCol from '@/components/element-ui/Col.js'

ElCol.install = function (Vue) {
  Vue.component(ElCol.name, ElCol)
}

// configure language
lang.el.pagination.goto = 'Go to page'
locale.use(lang)

Vue.use(Loading.directive)

// import components
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)

Vue.use(Row)
Vue.use(ElCol)

Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(InputNumber)
Vue.use(Checkbox)

Vue.use(Button)
Vue.use(ButtonGroup)
Vue.use(Tooltip)
Vue.use(Alert)
Vue.use(ColorPicker)

Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$loading = Loading.service
Vue.prototype.$notify = Notification
